import { useNavigate } from "react-router-dom";
import Layout from "../layouts/layout";
import { paths } from "../routes/paths";
import styles from "../styles/_screens/login.module.scss";

const Login = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.card}>
          <img src="/assets/logo.png" alt="logo" className={styles.logo} />
          <h1>Login</h1>

          <form>
            <input type="text" placeholder="Username" />
            <input type="password" placeholder="Password" />
            <button onClick={() => navigate(paths.dash)}>Login</button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default Login;
